// Refresh only while visible. The timer also covers projects where the table
// is not enabled for Realtime, without changing any database permissions.
export function startCompanyDataSync(client, userId) {
  let stopped = false
  let debounce = null
  let pendingReason = 'poll'
  const priorities = { poll: 0, foreground: 1, change: 2 }
  const refresh = reason => {
    if (stopped) return
    if (priorities[reason] > priorities[pendingReason]) pendingReason = reason
    if (document.hidden) return
    window.clearTimeout(debounce)
    debounce = window.setTimeout(() => {
      debounce = null
      if (stopped || document.hidden) return
      const reason = pendingReason
      pendingReason = 'poll'
      window.dispatchEvent(new CustomEvent('hubbing:companies-changed', { detail: { reason } }))
    }, 250)
  }
  const foreground = () => refresh('foreground')
  const channel = client.channel(`company-data-sync-${userId}`)
    .on('postgres_changes', { event: '*', schema: 'public', table: 'companies' }, () => refresh('change'))
    .subscribe()
  const interval = window.setInterval(() => refresh('poll'), 30000)
  window.addEventListener('focus', foreground)
  window.addEventListener('pageshow', foreground)
  document.addEventListener('visibilitychange', foreground)
  return () => {
    stopped = true
    window.clearTimeout(debounce)
    window.clearInterval(interval)
    window.removeEventListener('focus', foreground)
    window.removeEventListener('pageshow', foreground)
    document.removeEventListener('visibilitychange', foreground)
    client.removeChannel(channel)
  }
}

